import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../contexts/ThemeContext';
import usePageTitle from '../hooks/usePageTitle';
import PageMeta from '../components/SEO/PageMeta';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 1rem;
  min-height: 60vh;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: ${(props) => props.theme.primaryText};
  text-align: center;
  margin-bottom: 0.5rem;
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: ${(props) => props.theme.secondaryText};
  text-align: center;
  margin-bottom: 2rem;
  line-height: 1.5;
`;

const Placeholder = styled.p`
  color: ${(props) => props.theme.secondaryText};
  text-align: center;
  font-style: italic;
`;

const HowToUsePage = () => {
  const { theme } = useTheme();
  usePageTitle('How to Use Slick Picks');

  return (
    <Container>
      <PageMeta description="Step-by-step guide to using Slick Picks' MLB player prop predictions, Game Picks, and Picks of the Day in your own betting process." />
      <Title theme={theme}>How to Use SlickPicks</Title>
      <Subtitle theme={theme}>
        A walkthrough of our predictions, Game Picks, Picks of the Day, and how to use them when you bet.
      </Subtitle>
      <Placeholder theme={theme}>
        Content coming soon. This guide will walk through model predictions, Game Picks, Picks of the Day, and how to apply them to your betting.
      </Placeholder>
    </Container>
  );
};

export default HowToUsePage;
